<template>
  <div>
    <VDialog
      v-model="showResetPassDialog"
      max-width="400px"
      persistent
    >
      <VCard>
        <VContainer class="pa-4">
          <VRow>
            <VCol cols="12">
              <VTextField
                v-model="formData.user_password"
                :label="$t('auth.login.password')"
                :type="showPassword ? 'text' : 'password'"
                variant="outlined"
                required
                hide-details="auto"
                density="compact"
                class="mb-0"
                :error-messages="errorMsg"
              >
                <template #append>
                  <VBtn
                    @click="showPassword = !showPassword"
                  >
                    <VIcon>{{
                      showPassword ? "mdi-eye-off" : "mdi-eye"
                    }}</VIcon>
                    {{ showPassword ? "非表示" : "表示" }}
                  </VBtn>
                </template>
              </VTextField>
              <div
                :style="passwordScore.style">
                {{ passwordScore.message }}
              </div>
              <div v-debug>
                {{ passwordScore }}
              </div>
            </VCol>
            <VCol class="pt-0">
              <VCardActions class="d-flex justify-end">
                <VBtn
                  :disabled="formData.user_password.length === 0"
                  @click="submit()"
                >OK</VBtn>
                <VBtn
                  color="#AEAEAE"
                  :style="{
                    color: '#FFFFFF',
                  }"
                  @click="closeDialog()"
                >
                  {{ $t('common.cancel')}}
                </VBtn>
              </VCardActions>
            </VCol>
          </VRow>
        </VContainer>
      </VCard>
    </VDialog>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  data() {
    return {
      showResetPassDialog: false,
      showPassword: false,
      errorMsg: "",
      formData: {
        user_password: "",
      },
    };
  },
  computed: {
    ...mapState("Auth", ["user"]),
    passwordScore() {
      return this.processPwdScore();
    },
  },
  methods: {
    ...mapActions("Auth", [
      "M20901_ResetPassword"
    ]),
    openDialog() {
      return new Promise((resolve, reject) => {
        this.showResetPassDialog = true;
        this.$once('dialog-close', () => {
          resolve();
        });
      });
    },
    processPwdScore(){
      this.errorMsg = "";
      const result = {
        overallScore: 0,
        requiredScore: 0,
        message: "",
        style: null,
      }

      const pwd = this.formData.user_password;

      // Password: The password must contain at least 6 digits and alphanumeric characters.
      if(pwd !== null){
        // 教室 ユーザー種別 410～430; length: 5
        if(pwd.length >= 5 && [410, 420, 430].includes(this.user.user_type_code)){
          result.overallScore += 10;
          result.requiredScore += 10;
        // 講師、スタッフ	ユーザー種別 ≧ 300; length: 6
        } else if(pwd.length >= 6 && ![410, 420, 430].includes(this.user.user_type_code) && this.user.user_type_code >= 300){
          result.overallScore += 10;
          result.requiredScore += 10;
        }
        // 生徒	ユーザー種別 ＜ 199; length: 4
        if(pwd.length >= 4 && this.user.user_type_code < 199){
          result.overallScore += 10;
          result.requiredScore += 10;
        }

        const patterns =  [
          /\d/,           // 数字があるか
          /[a-z]/,        // 小文字のアルファベットがあるか
          /[A-Z]/,        // 大文字のアルファベットがあるか
          /[^a-zA-Z0-9]/  // 数字・アルファベット以外の文字
        ];

        patterns.forEach((pattern, index) => {

          if(pwd.match(pattern)) {
            result.overallScore += 10;
            if([0, 1].includes(index) && this.user.user_type_code >= 300){
              result.requiredScore += 10;
            }
          }

        });


      }
      else{
        return result
      }

      const baseStyle = {
        color: '#4b5563',           // text-gray-600
        fontSize: '0.75rem',        // text-xs
        fontStyle: 'italic',        // italic
        padding: '0.5rem',          // p-2
        marginTop: '0.5rem',        // my-2 -> mt-2
        marginBottom: '0.5rem',     // my-2 -> mb-2
        fontWeight: 'bold',         // font-bold
        borderRadius: '0.25rem',    // rounded
      }

      const score = result.overallScore;
      if (score >= 50) {
        result.style = { ...baseStyle, backgroundColor: '#bbf7d0', color: '#15803d' }; // green
        result.message =this.$t('auth.ResetPasswordDialog.ni')
      } else if (score >= 40) {
        result.style = { ...baseStyle,  backgroundColor: '#bfdbfe', color: '#1d4ed8' }; // blue
        result.message =this.$t('auth.ResetPasswordDialog.qiang-li')
      } else if (score >= 30) {
        result.style = { ...baseStyle,  backgroundColor: '#fed7aa', color: '#c2410c' }; // orange
        result.message =this.$t('auth.ResetPasswordDialog.pu-tong')
      } else if (score >= 20) {
        result.style = { ...baseStyle,  backgroundColor: '#fef08a', color: '#a16207' }; // yellow
        result.message =this.$t('auth.ResetPasswordDialog.cui-ruo')
      } else if (score >= 10) {
        result.style = { ...baseStyle,  backgroundColor: '#fecaca', color: '#b91c1c' }; // red
        result.message =this.$t('auth.ResetPasswordDialog.ni-0')
      }

      return result;
    },
    closeDialog() {
      this.showResetPassDialog = false;
      this.showPassword = false
      this.errorMsg = ""
      this.formData.user_password = ""
      this.$emit('dialog-close');
    },
    submit(){
      const scoreInfo = this.processPwdScore();

      // console.log(this.user.user_type_code >= 300 && scoreInfo.requiredScore < 30)
      // console.log(this.user.user_type_code < 199 && scoreInfo.requiredScore < 10)
      // console.log(this.user.user_type_code)
      // console.log(scoreInfo.requiredScore)
      if([410, 420, 430].includes(this.user.user_type_code) && scoreInfo.requiredScore < 30){
        this.errorMsg = this.$t('auth.ResetPasswordDialog.pasuwdohamukoto')
        return
      } else if(![410, 420, 430].includes(this.user.user_type_code) && this.user.user_type_code >= 300 && scoreInfo.requiredScore < 30){
        this.errorMsg = this.$t('auth.ResetPasswordDialog.pasuwdohamukoto-0')
        return
      }

      if(this.user.user_type_code < 199 && scoreInfo.requiredScore < 10){
        this.errorMsg = this.$t('auth.ResetPasswordDialog.pasuwdoha')
        return
      }

      this.M20901_ResetPassword(this.formData).then((res) => {
        if(res){
          this.$dialog.notify.success(this.$t('auth.ResetPasswordDialog.pasuwdowoshimashita'))
          this.closeDialog()
        } else {
          this.$dialog.notify.error(this.$t('auth.ResetPasswordDialog.pasuwdononishimashita'))
        }
      })
    }
  }
};
</script>
